import { css } from '@/styled-system/css';

export const desktopCTAsContainer = css({
  display: 'none',
  md: {
    display: 'flex',
    alignItems: 'center',
    gap: '1x',
    marginTop: '3x',
  },
});
